import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { CustomerEnum } from '../enums/customer.enum';
import { Inject } from '@angular/core';
import { ENVIRONMENT_TOKEN, EnvironmentToken } from '@ebw-monorepo/utils';

@Directive({
  selector: '[appCustomer]'
})
export class CustomerDirective {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    @Inject(ENVIRONMENT_TOKEN) private environment: EnvironmentToken
  ) {}

  @Input() set appCustomer(customers: CustomerEnum[]) {
    const customerFromConfig = this.environment.customer;
    const isCustomerAllowedToView = customers.some((cutomer: CustomerEnum) => cutomer === customerFromConfig);
    if (isCustomerAllowedToView && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!isCustomerAllowedToView && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
